import { Generic } from "types/filters-store.types";

export enum OperatorType {
  OR = "Or",
  AND = "And",
}

export enum RelationOperatorType {
  AT_LEAST = "at-least",
  NO_MORE = "no-more",
}

export enum FilterKeys {
  SEARCH_TERM = "searchProfiles",
  LOCATION = "location",
  SBA_CERTIFICATIONS = "sbaCertifications",
  NAICS = "naics",
  SELF_CERTIFICATIONS = "selfCertifications",
  KEYWORDS = "keywords",
  LAST_UPDATED = "lastUpdated",
  QUALITY_ASSURANCE_STANDARDS = "qualityAssuranceStandards",
  BONDING_LEVELS = "bondingLevels",
  SAM_STATUS = "samStatus",
  BUSINESS_SIZE = "businessSize",
  ANNUAL_REVENUE = "annualRevenue",
  ENTITY_DETAIL_ID = "entityDetailId",
}

export const FilterTitles = {
  [FilterKeys.LOCATION]: "Location",
  [FilterKeys.SBA_CERTIFICATIONS]: "SBA certifications",
  [FilterKeys.NAICS]: "NAICS",
  [FilterKeys.SELF_CERTIFICATIONS]: "Business type",
  [FilterKeys.KEYWORDS]: "Keywords",
  [FilterKeys.LAST_UPDATED]: "Last updated",
  [FilterKeys.QUALITY_ASSURANCE_STANDARDS]: "Quality assurance standards",
  [FilterKeys.BONDING_LEVELS]: "Bonding levels",
  [FilterKeys.SAM_STATUS]: "SAM.gov Status",
  [FilterKeys.BUSINESS_SIZE]: "Size",
  [FilterKeys.ANNUAL_REVENUE]: "Annual revenue",
  [FilterKeys.ENTITY_DETAIL_ID]: "Entity Detail ID",
};

export const ActiveSBACertifications: Generic[] = [
  {
    label: "8(a) or 8(a) Joint Venture",
    value: "1,4",
  },
  {
    label: "HUBZone",
    value: "3",
  },
  {
    label: "Women-Owned Small Business (WOSB)",
    value: "5",
  },
  {
    label: "Economically-Disadvantaged Women-Owned Small Business (EDWOSB)",
    value: "6",
  },
  {
    label: "Veteran-Owned Small Business (VOSB)",
    value: "7,8",
  },
  {
    label: "Service-Disabled Veteran-Owned Small Business (SDVOSB)",
    value: "9,10",
  },
];

export const SelfCertifications: Generic[] = [
  {
    label: "Self-Certified Small Disadvantaged Business",
    value: "Self-Certified Small Disadvantaged Business",
  },
  {
    label: "Self-Certified HUBZone Joint Venture",
    value: "HUBZone Joint Venture",
  },
  {
    label: "Self-Certified Veteran-Owned Small Business",
    value: "Veteran Owned Business",
  },
  // {
  //   label: "Self-Certified Service-Disabled Veteran-Owned Small Business",
  //   value: "Service Disabled Veteran Owned",
  // },
  {
    label: "Self-Certified Woman-Owned Small Business",
    value: "Women-Owned Small Business",
  },
  {
    label: "Self-Certified Woman-Owned Small Business Joint Venture",
    value: "Women-Owned Small Business Joint Venture",
  },
  {
    label: "Community Development Corporation (CDC) Owned Small Business",
    value: "Community Development Corporation Owned Firm",
  },
  // {
  //   label: "Any Minority Owned",
  //   value: "Minority-Owned business",
  // },
  {
    label: "Native American Owned",
    value: "Native American Owned",
  },
  {
    label: "Tribally Owned Small Business",
    value: "Tribally Owned Firm",
  },
  {
    label: "American Indian Owned Small Business",
    value: "American Indian Owned",
  },
  {
    label: "Alaskan Native Corp (ANC) Owned Small Business",
    value: "Alaskan Native Corporation Owned Firm",
  },
  {
    label: "Native Hawaiian Org (NHO) Owned Small Business",
    value: "Native Hawaiian Organization Owned Firm",
  },
  // TODO: Investigate additional Self-Certifications
  // {
  //   label: "Any non-Native American Minority Owned",
  //   value: "Minority Owned (non-Native American)",
  // },
];

export const LastUpdatedList: Generic[] = [
  {
    label: "Anytime",
    value: "anytime",
  },
  {
    label: "Within the past 3 months",
    value: "past-3-months",
  },
  {
    label: "Within the past 6 months",
    value: "past-6-months",
  },
  {
    label: "Within the past year",
    value: "past-year",
  },
  {
    label: "Custom",
    value: "custom",
  },
];

export const QASList: Generic[] = [
  {
    label: "ANSI/ASQC Z1.4",
    value: "ANSI/ASQC Z1.4",
  },
  {
    label: "ISO 9000 Series",
    value: "ISO-9000 Series",
  },
  {
    label: "ISO 10012-1",
    value: "ISO 10012-1",
  },
  {
    label: "MIL-Q-9858",
    value: "MIL-Q-9858",
  },
  {
    label: "MIL-STD-45662A",
    value: "MIL-STD-45662A",
  },
];

export const SortList: Generic[] = [
  {
    label: "Most relevant",
    value: "relevance",
  },
  {
    label: "Random",
    value: "random",
  },
  {
    label: "Alphabetical by small business name",
    value: "alphabetical",
  },
  {
    label: "Recently updated",
    value: "recently_updated",
  },
];

// This object maps self-certification labels to their corresponding filter labels used in market insights.
// These key/value pairs are essential for correctly setting and applying filters based on self-certifications (insights).
export const SelfCertificateMapped = {
  // Need further inquiry
  // "Minority-Owned Small Business": "Any Minority Owned",

  "Self-Certified Small Disadvantaged Business":
    "Self-Certified Small Disadvantaged Business",
  "Self-Certified HUBZone Joint Venture": "HUBZone Joint Venture",
  "Self-Certified Veteran-Owned Small Business":
    "Self-Certified Veteran-Owned Small Business",
  "Self-Certified Service-Disabled Veteran-Owned Small Business":
    "Self-Certified Service-Disabled Veteran-Owned Small Business",
  "Self-Certified Woman-Owned Small Business":
    "Self-Certified Woman-Owned Small Business",
  "Self-Certified Woman-Owned Small Business Joint Venture":
    "Self-Certified Woman-Owned Small Business Joint Venture",
  "Community Development Corporation (CDC) Owned Small Business":
    "Community Development Corporation (CDC) Owned Small Business",
  "Other Native American": "Native American Owned",
  "Tribally Owned Small Business": "Tribally Owned Small Business",
  "American Indian Owned Small Business":
    "American Indian Owned Small Business",
  "Alaskan Native Corp (ANC) Owned Small Business":
    "Alaskan Native Corp (ANC) Owned Small Business",
  "Native Hawaiian Org (NHO) Owned Small Business":
    "Native Hawaiian Org (NHO) Owned Small Business",

  // Need further inquiry
  // "Self-Certified Economically Disadvantaged Women-Owned Small Business": "",
};

export const SelfCertsV2: Generic[] = [
    {
      label: "Self-Certified Woman-Owned Small Business",
      value: "self_wosb_boolean"
    },
    {
      label: "Self-Certified Woman-Owned Small Business Joint Venture",
      value: "self_wosb_jv_boolean"
    },
    {
      label: "Self-Certified Veteran-Owned Small Business",
      value: "self_vosb_boolean"
    },
    {
      label: "Alaskan Native Corp (ANC) Owned Small Business",
      value: "self_anc_owned_boolean"
    },
    {
      label: "Other Native American",
      value: "self_native_owned_boolean"
    },
    {
      label: "Alaskan Native Corp (ANC) Owned Small Business",
      value: "self_nho_boolean"
    },
    {
      label: "American Indian Owned Small Business",
      value: "self_american_indian_owned_boolean"
    },
    {
      label: "Self-Certified Small Disadvantaged Business",
      value: "self_small_boolean"
    },
    {
      label: "Community Development Corporation (CDC) Owned Small Business",
      value: "self_cdc_boolean"
    },
    {
      label: "Tribally Owned Small Business",
      value: "self_tribal_owned_boolean"
    },
    // missing field in snowflake
    // {
    //   label: "Self-Certified HUBZone Joint Venture",
    //   value: "self_tribal_owned_boolean"
    // }
]

export const ExportList: Generic[] = [
  {
    label: "Export results table",
    value: "export-results-table",
  },
  {
    label: "Export email addresses",
    value: "export-email-addresses",
  }
];